import { useDispatch, useSelector } from "react-redux";
import LocationClient from "../../../assets/location-client.svg";
import LocationClientWhite from "../../../assets/LocationClientWhite.svg";
import { useEffect, useState } from "react";
import { setCity } from "../../../redux/slices/city";
import { clearProducts } from "../../../redux/slices/calculator";
import axios from "axios";
import "./ModalCities.scss";

const ModalCities = ({ navScroll, additionalClass }) => {
  const [cityName, setCityName] = useState("");
  const [userCity, setUserCity] = useState("");
  const [showCityChangePrompt, setShowCityChangePrompt] = useState(false);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { city } = useSelector(state => state.city);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get("/api/location/city");
        const data = response.data;
        console.log("Location data:", data);

        if (data.success) {
          setUserCity(data.city);

          if (data.isSupported) {
            // If city is supported (Moscow or Saint Petersburg)
            const cityIndex = data.city === "Москва" ? 0 : 1;
            setCityName(data.city);
            dispatch(setCity(cityIndex));
            setShowCityChangePrompt(false);
          } else {
            // If city is not supported, show prompt to change
            setCityName(data.city);
            setShowCityChangePrompt(true);
            // Default to Moscow
            dispatch(setCity(0));
          }
        } else {
          console.error("Location API returned error status");
          setCityName("Москва");
          dispatch(setCity(0));
          setShowCityChangePrompt(false);
        }
      } catch (error) {
        console.error("Error fetching location data:", error);
        setCityName("Москва");
        dispatch(setCity(0));
        setShowCityChangePrompt(false);
      }
    };
    getData();
  }, []);

  const onClickCities = i => {
    setOpen(false);
    dispatch(setCity(i));
    dispatch(clearProducts(i));
    setCityName(city && city.cities ? city.cities[i] : "");
    setShowCityChangePrompt(false);
  };

  const classes = `${additionalClass}`;

  return (
    <div
      className={
        navScroll ? `nav__citie nav__citie-scroll` : `nav__citie ${classes}`
      }>
      <div>
        <img
          className="nav__icon-client"
          src={navScroll ? LocationClientWhite : LocationClient}
          alt="icon"
        />
        <span onClick={() => setOpen(!open)}>
          {cityName}
          {showCityChangePrompt && (
            <span className="city-change-prompt">
              {" "}
              (Выберите город для заказа)
            </span>
          )}
        </span>
      </div>
      {open && (
        <div className="nav__cabinet-modal nav__citie-modal">
          <span
            onClick={() => setOpen(false)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              zIndex: -100,
            }}
          />
          {city?.cities?.map((item, index) => (
            <div
              key={index}
              onClick={() => onClickCities(index)}
              className="nav__cabinet-modal-link">
              {item}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ModalCities;
